
export enum Discipline {
  MEDICAL_ONCOLOGY = 'Medical Oncology',
  RADIATION_ONCOLOGY = 'Radiation Oncology',
  CARDIOLOGY = 'Cardiology'
}

export class ConvertDisciplineCodeToDisciplineName {
  public static getDiscipline(code: string): string {
    switch (code) {
      case '1':
        return 'Medical Oncology';
      case '2':
        return 'Radiation Oncology';
      case '3':
        return 'Cardiology';
    }
    return '';
  }
}

export const DRUGS_PROP: string = 'drugs';
export const THERAPIES_PROP: string = 'therapies';
export const DFCI_REGIMEN : string = 'DFCIRegimen';
export const DFCI_REGIMEN_CODE : string = 'content.DFCIRegimen.code';
export const DFCI_REGIMEN_CONCEPT: string = 'content.DFCIRegimen.concept';
export const LIST_DATA: string = 'listData';
export const LIST_TITLE: string = 'listTitle';
export const ITEM_TYPE: string = 'itemType';
export const ITEM_TITLE: string = 'itemTitle';
export const DRAG: string = 'Drug';
export const DRAGS_LIST = 'Drugs List';
export const CITATIONS_PROP = 'citations';
export const ARIA_TEMPLATES_PROP = 'ariaTemplates';
export const RATIONALIZATION_PROP = 'rationalization';
export const RATIONALIZATION_PATHWAY_NAME_S = 'rationalization.pathwayName';
export const THERAPY_DISPLAY_NAME = 'therapyDisplayName';
export const DRUG_DISPLAY_NAME = 'drugDisplayName';
export const DRUG_S = 'drug';
export const THERAPY_S = 'therapy';
export const DISCARD_WARNING = 'discardCurrentRevisionWarning';//'Are you sure you want to discard the current revision ?';
